__turbopack_context__.v({
  "loader": "j50j_W_loader",
});
